import { api } from "../api";
import { renderDocumentsTab, attachDocumentsListeners } from "./student-documents";
import { esc } from "../utils/html";

type LinkedSchool = { schoolId: number; schoolName: string; practiceId: number; linkedSince: string };

export async function render(el: HTMLElement) {
  el.innerHTML = `
    <div style="max-width:900px;margin:0 auto;padding:1rem">
      <h1 style="font-size:1.5rem;font-weight:600;margin-bottom:.25rem">Meine Dokumente</h1>
      <p style="color:var(--gray-600);font-size:.9rem;margin-bottom:1.25rem">
        Tausche hier Dokumente mit den Schulen aus, mit denen deine Einrichtung verknüpft ist.
        Lade eigene Dateien hoch oder lade von der Schule abgelegte Dokumente herunter.
      </p>
      <div id="practice-docs-root">
        <div class="card" style="padding:1.25rem">
          <p style="color:var(--gray-500);font-size:.9rem;margin:0">Lade…</p>
        </div>
      </div>
    </div>
  `;

  const root = el.querySelector<HTMLElement>("#practice-docs-root")!;

  let me;
  try {
    me = await api.practiceOrg.me();
  } catch (err: any) {
    root.innerHTML = `<div class="card" style="padding:1.25rem"><p style="color:var(--red-700);font-size:.9rem;margin:0">Fehler beim Laden: ${esc(err?.message || "unbekannt")}</p></div>`;
    return;
  }

  const schools: LinkedSchool[] = me.linkedSchools || [];

  if (schools.length === 0) {
    root.innerHTML = `
      <div class="card" style="padding:2rem 1.25rem;text-align:center;color:var(--gray-500)">
        <p style="font-size:.95rem;margin:0">Deine Einrichtung ist noch keiner Schule zugeordnet.</p>
        <p style="font-size:.85rem;margin:.5rem 0 0">Sobald eine Schule deinen Praktikumsstellen-Code verknüpft, kannst du hier Dokumente austauschen.</p>
      </div>`;
    return;
  }

  // Schul-Auswahl nur bei mehreren Verknüpfungen anzeigen
  const selectorHtml = schools.length > 1
    ? `<div class="card" style="padding:1rem 1.25rem;margin-bottom:1rem">
         <label for="practice-docs-school" style="display:block;font-size:.85rem;color:var(--gray-700);margin-bottom:.35rem">Schule</label>
         <select id="practice-docs-school" style="width:100%;max-width:24rem;padding:.45rem .55rem;border:1px solid var(--gray-300);border-radius:.375rem;font-size:.95rem">
           ${schools.map((s, i) => `<option value="${i}">${esc(s.schoolName)}</option>`).join("")}
         </select>
       </div>`
    : "";

  root.innerHTML = `
    ${selectorHtml}
    <div class="card" style="padding:1.25rem">
      <div id="practice-docs-container">${renderDocumentsTab()}</div>
    </div>`;

  const container = root.querySelector<HTMLElement>("#practice-docs-container")!;

  const mountForSchool = (school: LinkedSchool) => {
    container.innerHTML = renderDocumentsTab();
    attachDocumentsListeners({
      list: () => api.practiceOrg.documents.list(school.practiceId),
      upload: (file) => api.practiceOrg.documents.upload(school.practiceId, file),
      download: (docId, name) => api.practiceOrg.documents.download(school.practiceId, docId, name),
      delete: (docId) => api.practiceOrg.documents.delete(school.practiceId, docId),
      rename: (docId, name) => api.practiceOrg.documents.rename(school.practiceId, docId, name),
    }, container);
  };

  mountForSchool(schools[0]);

  const select = root.querySelector<HTMLSelectElement>("#practice-docs-school");
  select?.addEventListener("change", () => {
    const idx = Number(select.value);
    const school = schools[idx];
    if (school) mountForSchool(school);
  });
}
